import React from 'react';
import Form from 'react-bootstrap/Form';
import { Col, Container, FormGroup, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { useState, useEffect, useRef } from 'react';
import { Auth, SignOut, AddUserToGroup, CheckGroupName } from '../../../functions/ZIA'
import Spinner from 'react-bootstrap/Spinner';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBroom, faPaste, faCopy, faI } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Badge from 'react-bootstrap/Badge';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { objectToOperationString } from '../../../functions/misc';
import Multiselect from 'multiselect-react-dropdown';

library.add(faBroom, faPaste, faCopy)

function AddUsersToGroupTab({ groups, verified, showVerifyWindow, setShowVerifyWindow, setVerifyOperation, setVerified, selectedTab }) {
    const [isLoading, setLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState("Authenticating...")
    const [tenant, setTenant] = useState("Rheintec");
    const [group, setGroup] = useState("");
    const [outputConsole, setOutputConsole] = useState("");
    const [userText, setUserText] = useState("");
    const [userList, setUserList] = useState([]);
    const [updatedUsers, setUpdatedUsers] = useState([]);
    const [failedUsers, setFailedUsers] = useState([]);
    const [JSESSIONID, setJSESSIONID] = useState("");
    const [validated, setValidated] = useState(false);

    const sleep = ms => new Promise(r => setTimeout(r, ms));
    const textareaRef = useRef();
    const multiselectRef = useRef();

    const handleSelectGroup = (selectedList) => {
        if (selectedList.length > 0) {
            setGroup(selectedList[0].name);
        } else {
            setGroup('');
        }
    };

    function copyList(list) {
        const text = ListToText(list);
        navigator.clipboard.writeText(text);
    }

    function ListToText(list) {
        let text = "";
        for (let i = 0; i < list.length; i++) {
            text += i === 0 ? list[i] : "\n" + list[i];
        }
        return text;
    }
    function replaceUsers() {
        const text = ListToText(failedUsers);
        setUserText(text);
    }

    function appendConsole(text) {
        setOutputConsole(prevOutput => prevOutput + text);
    }
    function appendConsoleSeperatorMain(skipNewLine) {
        const width = textareaRef.current.clientWidth;
        const dashesCount = Math.floor(width / 8); // Adjust the number as needed
        const dashes = ('-'.repeat(dashesCount));
        setOutputConsole(prevOutput => prevOutput + (skipNewLine ? "" : "\n") + dashes);
    }
    function appendConsoleSeperatorSecondary() {
        const width = textareaRef.current.clientWidth;
        const dashesCount = Math.floor(width / 8); // Adjust the number as needed
        const dashes = ('-'.repeat(dashesCount / 2));
        setOutputConsole(prevOutput => prevOutput + "\n" + "\t" + dashes);
    }

    function clearUserText() {
        setUserText("");
        console.log("test");
    }

    function outputResponseUserStatus() {
        setOutputConsole("");
        appendConsoleSeperatorMain(true);
        appendConsole(`\nUpdated ${updatedUsers.length}/${userList.length} users:`);
        if (updatedUsers.length === 0) {
            appendConsoleSeperatorSecondary();
            appendConsole("\n\tNo users updated :(")
        }
        for (const user of updatedUsers) {
            appendConsoleSeperatorSecondary();
            appendConsole(`\n\tUser: ${user}`);
        }
        appendConsoleSeperatorSecondary();
        appendConsoleSeperatorMain();

        appendConsole(`\nFailed ${failedUsers.length}/${userList.length} users:`);
        if (failedUsers.length === 0) {
            appendConsoleSeperatorSecondary();
            appendConsole("\n\tNo users failed to update :)")
        }
        for (const fail of failedUsers) {
            appendConsoleSeperatorSecondary();
            appendConsole(`\n\tUser: ${fail.user} \n\tReason: ${fail.message}`);
        }
        appendConsoleSeperatorSecondary();
        appendConsoleSeperatorMain();
    }

    async function handleSubmit(event) {
        let users = userText.split('\n');
        users = users.map((user) => user.trim()).filter((user) => user !== "")
        if (!verified) {
            try {
                const obj = {
                    "Tenant": tenant,
                    "Operation": "Add users to group",
                    "Affected Resources": {
                        "Groups": [group],
                        "Users": users
                    }
                }
                const operationString = objectToOperationString(obj);
                setVerifyOperation(operationString);
                setShowVerifyWindow(true);

            } catch (error) {
                console.log(error)
            } finally {
                event.preventDefault();
                return
            }

        }
        setShowVerifyWindow(false)
        event.preventDefault();
        //Prerequisites
        setOutputConsole(``);
        setFailedUsers([]);
        setUpdatedUsers([]);
        setUserList([]);
        setLoading(true);
        event.preventDefault();

        //Authenticate
        setLoadingMessage("Initiating Session...");
        const json_session = await Auth(tenant);
        const session = json_session.session;
        setJSESSIONID(session);
        setOutputConsole(`Authenticated`);
        appendConsoleSeperatorMain();
        console.log(session);

        //Check Group Name
        setLoadingMessage("Checking group name...");
        const group_response = await CheckGroupName(group, session, tenant);
        if (group_response.status != 200) {
            const response_data = await group_response.json();
            appendConsole(`\nError: ${response_data.message}`);
            terminateSession(session);
            return;
        }
        //Read Users
        setLoadingMessage("Reading user list...");
        setUserList(users);
        appendConsole(`\n${users.length} user(s) detected`);
        appendConsoleSeperatorMain();

        //Add Users
        setLoadingMessage(`Adding users...`);
        for (const user of users) {
            try {
                let response = await AddUserToGroup(user, group, tenant, session)
                const response_data = await response.json();
                if (response.status === 200) {
                    setUpdatedUsers((prev) => [...prev, response_data.user])
                }
                else {
                    console.log(JSON.stringify(response_data))
                    setFailedUsers((prev) => [...prev, { user: response_data.user, message: response_data.message }]);
                }

            }
            catch (error) {
                console.log(error)
                setFailedUsers((prev) => [...prev, { user: user, message: error.message }]);
            }
        }


    }
    useEffect(() => {
        if (selectedTab === "addToGroup" && verified) {
            handleSubmit(new Event("LOL"))
        }
        setVerified(false);
    }, [verified])
    useEffect(() => {
        if (failedUsers.length > 0) {
            setLoadingMessage(`Adding users (${failedUsers.length + updatedUsers.length}/${userList.length})`);
            const failedUser = failedUsers[failedUsers.length - 1];
            appendConsoleSeperatorSecondary();
            appendConsole(`\n\tStatus: Failed \n\tUser: ${failedUser.user} \n\tReason: ${failedUser.message}`);
            if (failedUsers.length + updatedUsers.length == userList.length) {
                terminateSession(JSESSIONID);
                outputResponseUserStatus();
            }
        }

    }, [failedUsers]);

    useEffect(() => {
        if (updatedUsers.length > 0) {
            setLoadingMessage(`Adding users (${failedUsers.length + updatedUsers.length}/${userList.length})`);
            const updatedUser = updatedUsers[updatedUsers.length - 1];
            appendConsoleSeperatorSecondary();
            appendConsole(`\n\tStatus: Updated \n\tUser: ${updatedUser}`);
            if (failedUsers.length + updatedUsers.length == userList.length) {
                terminateSession(JSESSIONID);
                outputResponseUserStatus();
            }
        }
    }, [updatedUsers]);

    // Function to scroll the textarea to the bottom
    const scrollToBottom = () => {
        textareaRef.current.scrollTop = textareaRef.current.scrollHeight;
    };

    const scrollToTop = () => {
        textareaRef.current.scrollTop = 0;
    };
    useEffect(() => {
        scrollToBottom();
    }, [outputConsole])

    useEffect(() => {
        scrollToTop();
    }, [isLoading])
    useEffect(() => {
        console.log(group)
    }, [group])
    useEffect(() => {
        setGroup('')
        multiselectRef.current.resetSelectedValues();
    }, [tenant])


    async function terminateSession(JSESSIONID) {
        //Signout
        setLoadingMessage("Terminating Session...");
        await SignOut(JSESSIONID, tenant);
        setLoading(false);
    }
    return (
        <Container className=' pt-4 px-5 text-white pb-6'>
            <Row>
                <Col>
                    <Form validated={validated} onSubmit={handleSubmit}>
                        <FormGroup controlId="company">
                            <Form.Label>
                                Select tenant
                            </Form.Label>
                            <Form.Select aria-label="Default select example" value={tenant} onChange={(e) => setTenant(e.target.value)} >
                                {
                                    Object.keys(groups).map((key, index) => (
                                        <option key={index} value={key}>{key}</option>
                                    ))

                                }
                            </Form.Select>
                        </FormGroup>

                        <FormGroup controlId="groupName" className='mt-4'>
                            <Form.Label>
                                {groups[tenant].length === 0 ? <Spinner
                                    variant='light'
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                /> : <></>}
                                &nbsp;&nbsp;Group Name
                            </Form.Label>
                            <Multiselect
                                key={`${tenant}-${groups[tenant].length}`}
                                options={groups[tenant].map(groupName => ({ name: groupName, id: groupName }))}
                                displayValue="name"
                                onSelect={handleSelectGroup}
                                onRemove={handleSelectGroup}
                                ref={multiselectRef}
                                selectionLimit={1}
                                placeholder="Select Group"
                                showCheckbox="true"
                                showArrow="true"
                                customArrow={<FontAwesomeIcon icon="fa-solid fa-angle-down" style={{ color: "#c6cbce", }} size='sm' />}

                            />

                        </FormGroup>
                        <FormGroup controlId="userList" className='mt-4'>
                            <Form.Label className='w-100' >
                                <Container fluid className='pe-0'>
                                    <Row>
                                        <Col>
                                            <div className=''>User List</div>
                                        </Col>
                                        <Col className='text-end'>
                                            <Button disabled={failedUsers.length > 0 ? false : true} onClick={(e) => replaceUsers()} className='me-1 m-0 pt-0 pb-0 pm-1 rounded-0' variant={failedUsers.length > 0 ? "danger" : "primary"} size='sm' >
                                                <FontAwesomeIcon className='me-1' icon="fa-solid fa-paste" style={{ color: "#ffffff", }} />
                                                Replace with failed users <Badge bg="dark">{failedUsers.length}</Badge>
                                            </Button>
                                            <Button disabled={userText === "" ? true : false} onClick={(e) => clearUserText()} variant='primary' size='sm' className=' m-0 pt-0 pb-0 pm-1 rounded-0 text-light'>
                                                <FontAwesomeIcon className='me-1' size='sm' icon="fa-solid fa-broom" style={{ color: "#ffffff", }} />
                                                Clear users
                                            </Button>
                                        </Col>
                                    </Row>
                                </Container>

                            </Form.Label>
                            <Form.Control required value={userText} onChange={(e) => setUserText(e.target.value)} rows={5} as="textarea" placeholder="user1@rheintec.ch&#10;user2@rheintec.ch&#10;...." />
                        </FormGroup>

                        <Button className='mt-4 text-light' type='submit' disabled={isLoading || !group} >
                            {isLoading ?
                                <span>
                                    <Spinner
                                        variant='light'
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    {"  " + loadingMessage}
                                </span> : 'Add Users'}
                        </Button>
                    </Form>
                </Col>
            </Row>
            <Row className='mt-5 '>
                <Col>
                    <ProgressBar now={isLoading ? ((failedUsers.length + updatedUsers.length) / userList.length) * 100 : 0} />
                </Col>
                <Col md="auto" className='text-end'>
                    <Button disabled={updatedUsers.length > 0 ? false : true} onClick={(event) => { copyList(updatedUsers) }} className='rounded-0 pt-0 pb-0 pm-1' size='sm' variant={updatedUsers.length > 0 ? 'success' : 'primary'}>
                        <FontAwesomeIcon className='me-1' size='lg' icon="fa-solid fa-copy" style={{ color: "#ffffff", }} />
                        Copy updated users
                        <Badge className='ms-1' bg="dark">{updatedUsers.length}</Badge>
                    </Button>
                    <Button disabled={failedUsers.length > 0 ? false : true} onClick={(event) => { copyList(failedUsers.map(fail => fail.user)) }} className='ms-1 rounded-0 pt-0 pb-0 pm-1' size='sm' variant={failedUsers.length > 0 ? 'danger' : 'primary'}>
                        <FontAwesomeIcon className='me-1' size='lg' icon="fa-solid fa-copy" style={{ color: "#ffffff", }} />
                        Copy failed users
                        <Badge className='ms-1' bg="dark">{failedUsers.length}</Badge>
                    </Button>
                </Col>
            </Row>
            <Row className='mt-0 text-center'>
                <Col className=''>
                    <textarea value={outputConsole} className='w-100 bg-dark-subtle text-rheintec-blue output-terminal' rows="20" readOnly ref={textareaRef}>
                    </textarea>
                </Col>

            </Row>

        </Container>

    );

}

export default AddUsersToGroupTab;